import { render } from "./DailyPointsChart.vue?vue&type=template&id=0f3ae0c2&scoped=true"
import script from "./DailyPointsChart.vue?vue&type=script&lang=js"
export * from "./DailyPointsChart.vue?vue&type=script&lang=js"

import "./DailyPointsChart.vue?vue&type=style&index=0&id=0f3ae0c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3ae0c2"]])

export default __exports__